import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

export const PaperCard = ({ background, children, sx = {}, contentSx = {}, onClick, ...props }) => {
    const theme = useTheme();

    background = background || theme.palette.figma.block;

    return (
        <Box
            onClick={onClick}
            sx={{
                display: 'flex',
                flexDirection: 'column',
                borderRadius: '20px',
                boxShadow: theme.palette.shadows?.custom?.card || '0px 2px 8px rgba(0, 0, 0, 0.1)',
                border: 'none',
                position: 'relative',
                ...sx,
            }}
            {...props}
        >
            {/* Background */}
            < Box
                sx={{
                    position: 'absolute',
                    inset: 0,
                    borderRadius: '20px',
                    background: background,
                    zIndex: 0,
                }}
            />
            {/* Content */}
            <Box
                sx={{
                    position: 'relative !important',
                    zIndex: 2,
                    display: 'flex',
                    width: '100%',
                    padding: '20px',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: '10px',
                    ...contentSx,
                }}
            >
                {children}
            </Box>
        </Box >
    );
};